import React from "react";
import DayPicker, { DayPickerProps } from "react-day-picker";
import styled from "styled-components";
import "react-day-picker/lib/style.css";

// adding the wrapper component for now in case we want to customize the styles down the road to match our style guide
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function wrapDayPickerStyles(Component: any) {
  return styled(Component)``;
}

const StyledDayPicker = wrapDayPickerStyles(DayPicker);

export default function DeprecatedDayPickerComponent({
  ...props
}: DayPickerProps & { className?: string }) {
  return <StyledDayPicker {...props} />;
}
